import { ErrorScreen, Skeleton } from "@dash/skeleton";
import { useTheme } from "@emotion/react";
import { ChartData, ChartOptions } from "chart.js";
import { addDays } from "date-fns";
import React from "react";
import { Line } from "react-chartjs-2";
import tinycolor from "tinycolor2";

import { toDateString } from "@megaron/date-string";
import { useClientManager } from "@megaron/react-clients";

type Props = {
  groups: string[] | undefined;
};

export const options: ChartOptions<"line"> = {
  responsive: true,

  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        stepSize: 1,
      },
    },
    x: {},
  },
  plugins: {
    legend: {
      position: "top" as const,
    },
  },
};

export const DailyEventStats: React.FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  const since = toDateString(addDays(new Date(), -30));
  const until = toDateString(new Date());

  const query = useClientManager("loyaltyPoints")
    .dailyCodeActivity()
    .useQuery({ groupNames: props.groups, since, until });

  if (query.data === undefined) return <Skeleton />;
  if (query.error) return <ErrorScreen></ErrorScreen>;
  const days = query.data;

  const frontColor = "#d9d9d9";
  const backColor = tinycolor(theme.colors.primary).brighten(40).toHexString();
  const redeemColor = theme.colors.primary;

  const data: ChartData<"line"> = {
    labels: days.map((d) => d.date),
    datasets: [
      {
        label: "Wykorzystane kody",
        data: days.map((d) => d.redemptions),
        pointBackgroundColor: "transparent",
        pointBorderColor: "transparent",
        pointHoverBackgroundColor: redeemColor,
        borderColor: redeemColor,
        backgroundColor: redeemColor,
      },
      {
        label: "Skany (spód)",
        data: days.map((d) => d.scansWithKey),
        pointBackgroundColor: "transparent",
        pointBorderColor: "transparent",
        pointHoverBackgroundColor: backColor,
        borderColor: backColor,
        backgroundColor: backColor,
      },
      {
        label: "Skany (wierzch)",
        data: days.map((d) => d.scansWithoutKey),
        pointBorderColor: "transparent",
        pointBackgroundColor: "transparent",
        pointHoverBackgroundColor: frontColor,
        borderColor: frontColor,
        backgroundColor: frontColor,
      },
    ],
  };

  return (
    <div>
      <Line options={options} data={data} css={{ maxHeight: "350px" }} />
    </div>
  );
};
